import { withModalContext } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { PolicyChangeService } from 'gw-capability-gateway';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import NotesComponent from '../../Components/NotesComponent/NotesComponent';
import gatewayMessages from '../../gateway.messages';
import messages from './Notes.messages';
import metadata from './Notes.metadata.json5';

class EndorsementNotes extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        authHeader: PropTypes.shape({
            Authorization: PropTypes.string,
        }).isRequired,
        fromAccountLanding: PropTypes.shape({
            quoteDetailsData: PropTypes.shape({
                jobNumber: PropTypes.string,
                loadPolicyChangeSummaryCount: PropTypes.func,
            }),
            basePath: PropTypes.string,
        }).isRequired,
    };

    state = {
        notesData: [],
        loaded: true,
    };

    componentDidMount() {
        this.getNotes();
    }

    handleError = (title, message) => {
        const { modalContext } = this.props;
        return modalContext
            .showAlert({
                title: title,
                message: message,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok,
            })
            .catch(_.noop);
    };

    getNotes = async () => {
        const {
            authHeader,
            fromAccountLanding: {
                quoteDetailsData: { jobNumber, loadPolicyChangeSummaryCount },
            },
        } = this.props;
        this.setState({ loaded: false });
        try {
            const getAvailableNotesData =
                await PolicyChangeService.getNotesForPolicyChange(
                    [jobNumber],
                    authHeader
                );
            this.setState({
                notesData: getAvailableNotesData,
                loaded: true,
            });
            loadPolicyChangeSummaryCount();
        } catch (e) {
            this.handleError(
                gatewayMessages.modalError,
                gatewayMessages.errorLoadingNotes
            );
        }
    };

    createNote = async data => {
        const {
            authHeader,
            fromAccountLanding: {
                quoteDetailsData: { jobNumber },
            },
        } = this.props;
        this.setState({ loaded: false });
        try {
            const policyChangeNoteData =
                await PolicyChangeService.createNoteForPolicyChange(
                    [jobNumber, data],
                    authHeader
                );
            if (!_.isEmpty(policyChangeNoteData)) {
                this.getNotes();
            }
        } catch (e) {
            this.handleError(
                gatewayMessages.modalError,
                gatewayMessages.errorLoadingNotes
            );
        }
    };

    render() {
        const { notesData, loaded } = this.state;
        const translator = this.context;
        const overrides = {
            endorsementNotes: {
                initialNotesData: notesData,
                createNote: this.createNote,
                noDataMessage: translator(messages.noPolicyChangeNotes),
                visible: loaded,
                openActivitiesNote: false,
            },
            notesLoader: {
                loaded: loaded,
            },
        };
        const resolvers = {
            resolveComponentMap: {
                notescomponent: NotesComponent,
            },
        };
        return (
            <MetadataContent
                uiProps={metadata.pageContent}
                overrideProps={overrides}
                {...resolvers}
            />
        );
    }
}

export default withAuthenticationContext(withModalContext(EndorsementNotes));
